import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-lock-user-help-dialog',
  templateUrl: './lock-user-help-dialog.component.html',
  styleUrls: ['./lock-user-help-dialog.component.scss']
})
export class LockUserHelpDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LockUserHelpDialogComponent>, public dialog: MatDialog) { }

  ngOnInit() {
  }

}
